import { getFile } from "../helpers/fetch-wrapper";
import server from "./server";


export const loginUser = async (loginData) => {
  return server.post("/auth/login", loginData);
};

export const getProfile = async () => {
  try {
    return await server.get('/user/me');
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

    export const createTransaction = async (data) => {
      try {
        return await server.post('/transaction/create', data);
      } catch (error) {
        console.error('Error fetching:', error);
      }
    };

export const getAllTransactions = async (data) => {
  try {
    return await server.get(`/transaction/all?search=${data.search}&startDate=${data.startDate}&endDate=${data.endDate}&page=${data.page}&limit=${data.limit}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getMembersData = async () => {
  try {
    return await server.get(`/transaction/all-members`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getWorksByTransactionsData = async () => {
  try {
    return await server.get(`/transaction/works`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const deleteTransaction = async (id) => {
  try {
    return await server.delete(`/transaction/delete/${id}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const editTransaction = async (id, data) => {
  try {
    return await server.put(`/transaction/edit/${id}`, data);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const completedTasks = async (data) => {
  try {
    return await server.post('/completed-tasks/create', data);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getAllCompletedTasks = async (data) => {
  try {
    return await server.get(`/completed-tasks/all?search=${data.search}&startDate=${data.startDate}&endDate=${data.endDate}&page=${data.page}&limit=${data.limit}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getAllCarsForTasks = async (pageNumber) => {
  try {
    return await server.get(`/completed-tasks?page=${pageNumber}&pageSize=10`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getCompletedTaskDetails = async (id) => {
  try {
    return await server.get(`/completed-tasks/details/${id}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getCompletedTaskProducts = async (id) => {
  try {
    return await server.get(`/completed-tasks/products/${id}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const editCompletedTask = async (id, data) => {
  try {
    return await server.put(`/completed-tasks/edit/${id}`, data);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const deleteCompletedTask = async (id) => {
  try {
    return await server.delete(`/completed-tasks/delete/${id}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const downloadCompletedTasks = async (id) => {
  // const url = `http://localhost:3003/completed-tasks/download/${id}`
  const url = `https://admin-api.autocar.am/completed-tasks/download/${id}`
  await getFile(url, id);
};

export const getAllCars = async (data) => {
  try {
    return await server.get(`/cars?search=${data.search}&startDate=${data.startDate}&endDate=${data.endDate}&page=${data.page}&limit=${data.limit}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getCarsModels = async () => {
  try {
    return await server.get('/cars/all');
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const createCar = async (data) => {
  try {
    return await server.post('/cars/create', data);
  } catch (error) {
    console.error('Error fetching:', error.response);
    if (error.response) {
      return error.response.data;
    } else {
      return { message: error.message };
    }
  }
};

export const editCar = async (id, data) => {
  try {
    return await server.put(`/cars/${id}`, data);
  } catch (error) {
    console.error('Error fetching:', error.response);
    if (error.response) {
      return error.response.data;
    } else {
      return { message: error.message };
    }
  }
};

export const deleteCar = async (id) => {
  try {
    return await server.delete(`/cars/${id}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getCarDetails = async (id) => {
  try {
    return await server.get(`/cars/details/${id}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const checkCars = async (field, value) => {
  try {
    return await server.get(`/cars/check/${field}/${value}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const checkHasCar = async (value) => {
  try {
    return await server.get(`/cars/check/${value}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getOilTypes = async () => {
  try {
    return await server.get('/oil/types');
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const oilChangeDetails = async (data) => {
  try {
    return await server.post('/oil/create', data);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getAllOils = async (data) => {
  try {
    return await server.get(`/oil?startDate=${data.startDate}&endDate=${data.endDate}&page=${data.page}&limit=${data.limit}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const editOil = async (id, data) => {
  try {
    return await server.put(`/oil/${id}`, data);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const deleteOil = async (id) => {
  try {
    return await server.delete(`/oil/${id}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const dailyDashboard = async () => {
  try {
    return await server.get("/dashboard/income");
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const countStatsDashboard = async () => {
  try {
    return await server.get("/dashboard/stats");
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const createTeamMember = async (data) => {
  try {
    return await server.post("/team-member", data);
    // const response = await server.post("/team-member", data, {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //   },
    // });
    // return response;

  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const getAllMembers = async (data) => {
  try {
    return await server.get(`/team-member?search=${data.search}&page=${data.page}&limit=${data.limit}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const deleteMember = async (id) => {
  try {
    return await server.delete(`/team-member/${id}`);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const editMember = async (id, data) => {
  try {
    return await server.put(`/team-member/${id}`, data);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};

export const sendEmail = async (data) => {
  try {
    return await server.post(`notification/send`, data);
  } catch (error) {
    console.error('Error fetching:', error);
  }
};